import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../commons/KpiTable';
import { round } from 'lodash';

const LearningReachedLevelRateTable = (props) => (
  <KpiTable
    title="Reached level rate"
    description={`The percent of students that reached the level of their course in the test. The column "Course progress" shows the average course progress at test execution moment of all students who did the test in the course.`}
    nameColumnLabel="Bonus Test source course"
    firstDataColumnLabel="Rate"
    firstDataColumnPath="rate"
    loading={props.loading}
    values={props.values}
    formatter={props.formatter}
    feedbackColorRender={props.feedbackColorRender}
    additionalColumns={[
      {
        label: 'Course progress %',
        path: 'extra.averageCourseProgress',
        render: (value) => `${round(value, 2)}%`,
      },
      {
        label: 'Number of tests',
        path: 'total',
      },
    ]}
  />
);

LearningReachedLevelRateTable.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

export default LearningReachedLevelRateTable;
